var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2786 1.80204C10.3942 4.95101 14.3588 7.51557 17.274 9.0308L17.2736 10.4304C14.3574 11.7142 10.5078 14.1647 10.5068 17.1971L8.40746 17.1978C8.29194 13.8156 11.7916 11.4818 14.2411 10.6646L1.17862 10.4357L1.17931 8.33631L14.2418 8.56528C11.6762 7.86634 8.06152 5.18504 8.17926 1.80273L10.2786 1.80204Z",
    fill: "#0898A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTeal);
export default __webpack_public_path__ + "static/media/arrow-right-teal.be6b0a8456415ae7c4ed5d5dea07af69.svg";
export { ForwardRef as ReactComponent };